(function () {
	function initAccordions(root) {
		var items = root.querySelectorAll('.pdp-faq__item.accordion');
		items.forEach(function (item) {
			var trigger = item.querySelector('.accordion__trigger');
			var panel = item.querySelector('.accordion-inner');
			if (!trigger || !panel) return;

			trigger.addEventListener('click', function () {
				var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
				var group = item.closest('[data-accordion-group]');

				// Close all siblings in the group
				if (group) {
					group.querySelectorAll('.pdp-faq__item.accordion').forEach(function (sibling) {
						if (sibling === item) return;
						var sibTrigger = sibling.querySelector('.accordion__trigger');
						if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
						sibling.classList.remove('active');
					});
				}

				// Toggle this item
				trigger.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
				item.classList.toggle('active', !isExpanded);
			});
		});
	}

	function initFilters(root) {
		var filters = root.querySelectorAll('[data-pdp-faq-filters] [data-category]');
		var items = root.querySelectorAll('[data-pdp-faq-list] [data-categories]');
		if (!filters.length || !items.length) return;

		filters.forEach(function (btn) {
			btn.addEventListener('click', function () {
				var cat = btn.getAttribute('data-category');
				filters.forEach(function (b) {
					var active = b === btn;
					b.classList.toggle('is-active', active);
					b.setAttribute('aria-pressed', active ? 'true' : 'false');
				});
				items.forEach(function (item) {
					var cats = (item.getAttribute('data-categories') || '').split(' ');
					item.hidden = cat !== 'all' && cats.indexOf(cat) === -1;
				});
			});
		});
	}

	function init(root) {
		initFilters(root);
		initAccordions(root);
	}

	function boot() {
		document.querySelectorAll('[data-pdp-faq]').forEach(init);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
